import { Button, NumberBox, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import React, { useState } from "react";
import { Document, Page } from "react-pdf";

export default function TrainingReportFileViewer(props) {
  const { itemData } = props;

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.3);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onClickBefore = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const onClickRight = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const onChangePageNumber = (e) => {
    setPageNumber(Number(e.event.target.value));
  };

  const onClickAdd = () => {
    setScale(scale * 1.1);

    const box = document.getElementById("SOPPDFViewer");
  };

  const onClickMinus = () => {
    setScale(scale / 1.1);
  };

  return (
    <React.Fragment>
      {itemData.data && (
        <div style={{ width: "100%", overflow: "auto" }}>
          <Toolbar>
            <Item location={"before"}>
              <Button
                icon="arrowleft"
                style={{ backgroundColor: "#f5f5f5" }}
                onClick={onClickBefore}
              />
            </Item>
            <Item location={"before"}>
              <Button
                icon="arrowright"
                style={{ backgroundColor: "#f5f5f5" }}
                onClick={onClickRight}
              />
            </Item>
            <Item location={"before"}>
              <div
                style={{
                  width: "30px",
                  fontSize: "30px",
                  color: "#f5f5f5",
                  textAlign: "center",
                }}
              ></div>
            </Item>
            <Item location={"before"}>
              <NumberBox
                value={pageNumber}
                width={50}
                min={1}
                max={numPages}
                onChange={onChangePageNumber}
              />
            </Item>
            <Item location="before" text={` / `} />
            <Item location="before" text={numPages} />
            <Item location={"before"}>
              <div
                style={{
                  width: "30px",
                  fontSize: "30px",
                  color: "#f5f5f5",
                  textAlign: "center",
                }}
              ></div>
            </Item>
            <Item location={"before"}>
              <Button
                icon="add"
                style={{ backgroundColor: "#f5f5f5" }}
                onClick={onClickAdd}
              />
            </Item>
            <Item location={"before"}>
              <Button
                icon="minus"
                style={{ backgroundColor: "#f5f5f5" }}
                onClick={onClickMinus}
              />
            </Item>
          </Toolbar>
          <div
            style={{
              overflow: "auto",
              // height: 1100,
              borderTop: "1px solid #e0e0e0",
              maxHeight: "calc(100vh - 200px)",
            }}
          >
            <Document
              className={"document"}
              // file={`http://218.232.108.62:9000/api/lrnMgmt/trRec/rpt/file/${itemData.data.tpId}/${itemData.data.SEQ}?filePath=${itemData.data.text}`}
              file={{
                // url: `https://betree.beccocro.com:9000/api/lrnMgmt/trRec/rpt/file/${itemData.data.tpId}/${itemData.data.SEQ}?filePath=${itemData.data.text}`,
                url: `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/file/${itemData.data.tpId}/${itemData.data.SEQ}?filePath=${itemData.data.text}`,
                withCredentials: true,
              }}
              // file={`${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${employeeNo}`}
              // file={`http://218.232.108.62:9000/api/SOPViewer/QMP001/Initial/22040107`}
              onLoadSuccess={onLoadSuccess}
              onContextMenu={(e) => e.preventDefault()}
            >
              <Page
                pageNumber={pageNumber}
                // height={853 - 56}
                scale={scale}
                // customTextRenderer={textRender}
                className={"page"}
              />
              {/* {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={scale}
                  className={"page"}
                />
              ))} */}
            </Document>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
